import { c as _c } from "react/compiler-runtime";
import { gql, useMutation } from '@material-bank/graphql-client';
import type { CoordinatesInput, Tag } from '@material-bank/mtag-graphql-schema';
type TagTapMutationData = {
  tagTap: Pick<Tag, 'id' | 'tagRef'>;
};
export type TagTapMutationVars = {
  tagRef: string;
  fingerprint: string;
  nonce: string;
  location?: CoordinatesInput | null;
};
const tagTapMutation = gql`
  mutation TagTap(
    $tagRef: String!
    $fingerprint: UUID!
    $nonce: String!
    $location: CoordinatesInput
  ) {
    tagTap(
      tagRef: $tagRef
      fingerprint: $fingerprint
      nonce: $nonce
      location: $location
    ) {
      id
      tagRef
    }
  }
`;
export function useTagTapMutation() {
  const $ = _c(5);
  const [mutate, t0] = useMutation(tagTapMutation);
  const {
    data,
    error,
    loading
  } = t0;
  const t1 = data?.tagTap;
  let t2;
  if ($[0] !== error || $[1] !== loading || $[2] !== mutate || $[3] !== t1) {
    t2 = {
      recordTap: mutate,
      data: t1,
      error,
      loading
    };
    $[0] = error;
    $[1] = loading;
    $[2] = mutate;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}